import { IUpdateOcorrenciaInspecaoPatrimonioUseCase } from "../../../presentation/useCases/update/update_ocorrencia_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateOcorrenciaInspecaoPatrimonioUseCase
 */

export class UpdateOcorrenciaInspecaoPatrimonioUseCase implements IUpdateOcorrenciaInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateOcorrenciaInspecaoPatrimonio(
    idOcorrenciaInspecaoPatrimonio: number,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    idInspecaoPatrimonio?: number,
    idInspecaoPatrimonioItens?: number,
    dataCriacao?: Date,
    descricao?: string,
    inspecao?: number,
    arquivo1?: File,
    arquivo2?: File,
    descricaoArquivo1?: string,
    descricaoArquivo2?: string,
  ): Promise<void> {
    const computedNomeArquivo = arquivo1 ? arquivo1.name : undefined;
    const computedArquivo = arquivo1 ? arquivo1 : undefined;

    const computedNomeArquivo2 = arquivo2 ? arquivo2.name : undefined;
    const computedArquivo2 = arquivo2 ? arquivo2 : undefined;

    await this.repository.updateOcorrenciaInspecaoPatrimonio(
      idOcorrenciaInspecaoPatrimonio,
      limparArquivo1,
      limparArquivo2,
      idInspecaoPatrimonio,
      idInspecaoPatrimonioItens,
      dataCriacao,
      descricao,
      inspecao,
      computedArquivo,
      computedArquivo2,
      computedNomeArquivo,
      computedNomeArquivo2,
      descricaoArquivo1,
      descricaoArquivo2
    );
  }
}
